import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import {
    Box,
    Button,
    Chip,
    CircularProgress,
    Container,
    Grid,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';

// components
import { ProductList } from '../sections/@dashboard/products';
// mock
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import AddButton from 'src/components/Button.js/AddBotton';
import FilterDevice from 'src/components/fillter/FilterDevice';
import Loader from 'src/components/loader/loader';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import DeviceModal from 'src/components/modal/Device';
import { glb_sv, sendRequest, serviceList } from 'src/utils';

import moment from 'moment';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { Link as RouterLink } from 'react-router-dom';
import EmtyData from 'src/components/emty-data';
import Iconify from 'src/components/iconify/Iconify';
import CreateDeviceExcelModal from 'src/components/modal/CreateDeviceExcelModal';
import CreatePropertyExcelModal from 'src/components/modal/CreatePropertyExcelModal';
import * as XLSX from 'xlsx';
import useUploadFileLocationHook from './ProductPage/uploadFileLocationHook';
import UpdateDeviceLocationExcelModal from './ProductPage/updateDeviceLocationExcelModal';
import DowloadDeviceLocationExample from './ProductPage/dowloadDeviceLocationExample';
import ManyButton from 'src/components/modal/ManyButton';
import TableLocationDevice from './ProductPage/tableLocationDevice';
import TableProperty from './ProductPage/tableProperty';
import ProductFilterSidebarHaveGroup from 'src/components/fillter/ProductFilterSidebarHaveGroup';
import { exportToExcel } from 'src/utils/exportExcel';
// ----------------------------------------------------------------------

export default function ProductsPage() {
    const [visible, setVisible] = useState(false);
    const [visibleDel, setVisibleDel] = useState(false);
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const { t } = useTranslation();
    const params = useParams();
    const delFlags = useRef(false);
    const arrFillters = useRef([]);
    const isEdit = useRef(false);
    const [data, setData] = useState({});
    const [deleleFlags, setDeleleFlags] = useState(false);
    const [arrProperties, setProperties] = useState([]);
    const getRef = useRef(false);

    const fileInputRef = useRef(null);

    const [visibleExcel, setVisibleExcel] = useState(false);
    const [visibleDeviceLocationExcel, setVisibleDeviceLocationExcel] = useState(false);
    const [checkDataExcel, setCheckDataExcel] = useState(false);
    const [dataExcel, setDataExcel] = useState([]);
    const [totalDataExcel, setTotalDataExcel] = useState(0);
    const dataLengthRef = useRef(0);

    const fileInputRefProperty = useRef(null);
    const fileInputRefDeviceLocation = useRef(null);
    const [err, setErr] = useState(false);
    const getDepartmentFlags = useRef(false);

    const [departments, setDepartments] = useState([]);
    const [visibleExcelProperty, setVisibleExcelProperty] = useState(false);
    const [checkDataExcelProperty, setCheckDataExcelProperty] = useState(false);
    const [dataExcelProperty, setDataExcelProperty] = useState([]);
    const [totalDataExcelProperty, setTotalDataExcelProperty] = useState(0);
    const [dataLocationDeviceExcel, setDataLocationDeviceExcel] = useState([]);
    const [infoGroup, setInfoGroup] = useState({
        group_nm: '',
        group_cd: '',
    });
    const [dataAllGroup, setDataAllGroup] = useState([]);
    const tableLocationDeviceRef = useRef(null);
    const tablePropertyRef = useRef(null);
    const dataLengthRefProperty = useRef(0);
    const tableRef = useRef(null);
    const tableDeviceLocationRef = useRef(null);

    const getGroup = useRef();
    const getAllGroup = useRef();
    const [property, setProperty] = useState([]);

    const [openFilter, setOpenFilter] = useState(false);

    const user = useRef({});
    user.current = glb_sv.userInfo;

    const [visibleDownloadQR, setVisibleDownloadQR] = useState(false);
    const [screenPermissions, setScreenPermissions] = useState({});

    const deleteTableExcel = () => {
        const InVal = [];
        sendRequest(serviceList.delExcelDevice, InVal, deleteExcelResult, true, timeOutDeleteTabbelExcel, 40000);
    };

    const deleteTableExcelLocation = () => {
        const InVal = [];
        sendRequest(
            serviceList.deleteTempDeviceLocation,
            InVal,
            deleteExcelResult,
            true,
            timeOutDeleteTabbelExcel,
            40000
        );
    };

    const tableRefExportDevice = useRef(null);
    const {
        checkDataExcel: checkDataExcelDeviceLocation,
        dataExcel: dataExcelDeviceLocation,
        setDataExcel: setDataExcelDeviceLocation,
        handleFileUploadLocationDeviceProperty,
    } = useUploadFileLocationHook({
        deleteTableExcel: deleteTableExcelLocation,
        dataLengthRef: dataLengthRef,
        departments: departments,
        fileInputRef: fileInputRefDeviceLocation,
        idGroup: +params.idGroup,
        infoGroup: infoGroup,
        setVisibleExcel: setVisibleDeviceLocationExcel,
        t: t,
    });

    // Đếm có thiết bị nào bị cảnh báo hoặc lỗi khi import excel
    const [errCount, setErrCount] = useState(0);

    useEffect(() => {
        setTimeout(() => {
            if (dataLocationDeviceExcel.length === 0) {
                getDataLocationDevice();
            }
            if (dataAllGroup.length === 0) {
                getDataAllGroup();
            }
            getDataDepartment();
            getDataGroups();
            getData();
        }, 1000);
    }, [arrProperties, dataAllGroup]);

    useEffect(() => {
        if (err) {
            toast.error(t('Error'));
            setErr(false);
        }
    }, [err]);

    const getDataDepartment = useCallback(() => {
        if (getDepartmentFlags.current) {
            return;
        }
        getDepartmentFlags.current = true;
        const InVal = [1];
        sendRequest(serviceList.getAlldepartment, InVal, getDataResultDepartment, true, timeOutFunctDepartment, 40000);
    }, []);

    const getDataResultDepartment = (reqInfoMap, message) => {
        getDepartmentFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDepartments(message.proc_data.rows[0].o_1);
            // console.log('Departments', message);
        }
    };

    const getDataLocationDevice = useCallback(() => {
        const InVal = [Number(params.idGroup)];
        sendRequest(
            serviceList.getListDeviceLocation,
            InVal,
            getDataLocationDeviceResult,
            true,
            timeOutFunctDepartment,
            40000
        );
    }, []);

    const getDataLocationDeviceResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataLocationDeviceExcel(message.proc_data.rows[0].o_1);
            // console.log('Departments', message);
        }
    };

    const timeOutFunctDepartment = (reqInfo) => {
        getDepartmentFlags.current = false;
    };

    const getData = useCallback(() => {
        const arrFillters = arrProperties.map((item) => {
            const checkedValues = item.value
                .filter((subItem) => subItem.checked === true)
                .map((subItem) => subItem.value);
            return { label: item.label, value: checkedValues };
        });

        if (getRef.current) {
            return;
        }
        setGetFlags(true);
        getRef.current = true;
        const listGroupSelect = dataAllGroup
            .filter((ele) => ele.checked)
            .map((ele) => ele.id)
            .filter(Boolean);
        const InVal = [
            +params.idPermission,
            9999999999999999999,
            '',
            listGroupSelect?.length == 0 ? [+params.idGroup] : listGroupSelect,
            arrFillters.filter((item) => item.value.length > 0),
            user.current.depart_cd,
        ];
        sendRequest(serviceList.getAllDeviceMoreGroup, InVal, getDataResult, true, timeOutFunct, 40000);
        // console.log('proc', InVal);
    }, [arrProperties, dataAllGroup]);

    const getDataResult = (reqInfoMap, message) => {
        setGetFlags(false);
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
            arrFillters.current = message.proc_data.rows[0].o_1;
            setScreenPermissions(message.proc_data.rows[1].o_1[0][0]);
        }
    };

    const timeOutFunct = (reqInfo) => {
        setGetFlags(false);
        getRef.current = false;
        toast.error(t('error.time_out'));
    };

    const handleDelete = () => {
        if (!data.id) return toast.error(t('error.system_error'));
        if (delFlags.current) {
            return;
        }
        setDeleleFlags(true);
        delFlags.current = true;
        const InVal = ['1', data.id, +params.idPermission];
        sendRequest(serviceList.deleteDevice, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const handleDeletePrototy = (item, index, indexParent) => {

        if (item) {
            arrProperties[indexParent].value[index] = {
                ...arrProperties[indexParent].value[index],
                checked: !arrProperties[indexParent].value[index].checked,
            };
            setProperties([...arrProperties]);
        }
    };

    const deleteResult = (reqInfoMap, message) => {
        setDeleleFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleDel(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleDel(false);
            getData();
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setDeleleFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };

    const fillterSearcher = (value) => {
        if (value === '' || !value) {
            return setTableData(arrFillters.current);
        }
        const arrSearch = arrFillters.current.filter(
            (data) => data.device_nm.includes(value.toUpperCase()) || data.device_cd.includes(value.toUpperCase())
        );
        setTableData(arrSearch);
    };

    const onDownload = () => exportToExcel(tableRef, t('download_file'));

    const onDownloadDeviceLocationExmaple = () =>
        exportToExcel(tableDeviceLocationRef, t('download_file') + ' ' + t('device_location'));

    // const { onDownload: onDownloadDeivceLocation } = exportToExcel(
    //     tableLocationDeviceRef,
    //     t('export_list') + ' ' + t('device') + ' ' + t('location')
    // );
    // export devices
    const onDownloadExportDevices = () => exportToExcel(tableRefExportDevice, t('export_file_device'));
    const onDownloadProperty = () => exportToExcel(tablePropertyRef, t('list_property'));
    // import devices
    const handleFileUpload = (event) => {
        setDataExcel([]);
        deleteTableExcel();
        if (event.target.files?.length > 0) {
            setCheckDataExcel(true);
            const file = fileInputRef.current.files[0];
            try {
                const reader = new FileReader();

                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    if (workbook.SheetNames?.length > 0) {
                        // Lấy dữ liệu từ sheet đầu tiên
                        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        if (jsonData?.length > 0) {
                            jsonData.map((user, idx) => {
                                const note = [];
                                if (idx !== 0)
                                    if (user?.length > 12) {
                                        const arrProperties = [];
                                        const arrDepartments = [];
                                        const departmentExcel = user[11].split(',').map((item) => item.trim());

                                        if (departmentExcel?.length > 0) {
                                            departmentExcel.forEach((item) => {
                                                const matchedItem = departments.find((obj) => obj.depart_cd === item);
                                                if (matchedItem) {
                                                    arrDepartments.push({
                                                        label: matchedItem.departs_nm,
                                                        value: matchedItem.depart_cd,
                                                    });
                                                } else {
                                                    note.push(t('not_found_department') + ` ${item}. `);
                                                }
                                            });
                                        }

                                        if (user?.length > 13) {
                                            user.map((properties, index) => {
                                                if (index > 12) {
                                                    arrProperties.push({
                                                        label: jsonData[0][index],
                                                        value: `${properties}`,
                                                    });
                                                }
                                            });
                                        }

                                        const extractNumbers = (input) => {
                                            if (
                                                typeof input === 'string' &&
                                                input.trim().match(/^\[\s*(\d+)\s*:\s*(\d+)\s*\]$/)
                                            ) {
                                                // Nếu input là chuỗi và có định dạng [ number : number ]
                                                // const sliceStr = input.trim().slice(1, -1).trim().replace(/\s+/g, '').split(':');
                                                const regex = /\d+/g;
                                                const matches = input.match(regex);
                                                if (matches) {
                                                    return { row: Number(matches[0]), column: Number(matches[1]) };
                                                }
                                            } else if (typeof input === 'number') {
                                                // Nếu input là số
                                                return { row: 1, column: input };
                                            }
                                            toast.error(t('data_file_err_cells'));
                                            return null;
                                        };

                                        let cell_lc_nums = extractNumbers(user[2]);
                                        if (cell_lc_nums === null) {
                                            cell_lc_nums = null;
                                        } else {
                                            cell_lc_nums = JSON.stringify(cell_lc_nums)
                                                .replace(/,/g, ', ')
                                                .replace(/:/g, ': ');
                                        }

                                        if (user[5] !== infoGroup.group_cd) {
                                            note.push(
                                                t('code_group') +
                                                    ` ${user[5]} ` +
                                                    t('not_equal_group_cd') +
                                                    ` ${infoGroup.group_cd}.`
                                            );
                                        }

                                        importExcel([
                                            user[5],
                                            user[6],
                                            user[7],
                                            user[8],
                                            `${user[10]}` === '0'
                                                ? moment()
                                                      .add(+user[9] ? +user[9] : 1, 'months')
                                                      .format('YYYYMMDD')
                                                : '',
                                            `${user[10]}` === '0' || `${user[10]}` === '1' ? `${user[10]}` : '1',
                                            JSON.stringify([...arrDepartments, { label: 'admin', value: 'admin' }]),
                                            user[12],
                                            JSON.stringify(arrProperties),
                                            user[0],
                                            user[1],
                                            cell_lc_nums,
                                            user[3],
                                            user[4],
                                            note,
                                        ]);
                                    } else if (user?.length < 12 && user?.length > 0) {
                                        setTimeout(() => {
                                            toast.error(`${t('row_data')}${idx} ${t('invalid')}`);
                                        }, idx * 100 + 1000);
                                        console.log('data', idx, user);
                                    }
                                if (idx + 1 === jsonData?.length) {
                                    setVisibleExcel(true);
                                }
                            });
                        } else {
                            toast.error(t('data_file_err'));
                        }
                    } else {
                        toast.error(t('file_excel_err'));
                    }
                    // In ra dữ liệu từ file Excel
                };

                reader.readAsArrayBuffer(file);
            } catch (error) {}
            setCheckDataExcel(false);
        } else {
            toast.error(t('file_excel_err'));
        }
        fileInputRef.current.value = '';
    };
    // import properties group
    const handleFileUploadProperty = (event) => {
        setDataExcelProperty([]);
        deleteTableExcelProperty();
        if (event.target.files?.length > 0) {
            setCheckDataExcelProperty(true);
            const file = fileInputRefProperty.current.files[0];
            try {
                const reader = new FileReader();

                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    if (workbook.SheetNames.length > 0) {
                        // Lấy dữ liệu từ sheet đầu tiên
                        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        // console.log(jsonData);
                        if (jsonData?.length > 0) {
                            const arrProperties = [];
                            for (let i = 0; i < jsonData.length; i++) {
                                // kiem tra định dạng excel
                                if (i > 0) {
                                    if (jsonData[i].length === 2) {
                                        // console.log(jsonData[i], jsonData[i][1]?.split(','));

                                        // console.log(i, jsonData.length);
                                        arrProperties.push({
                                            label: jsonData[i][0] ? jsonData[i][0] : '',
                                            id: generateUniqueId(),
                                            value: jsonData[i][1]
                                                ? `${jsonData[i][1]}`.split(',').map((item) => item.trim())
                                                : '',
                                        });
                                    } else {
                                        setTimeout(() => {
                                            toast.error(`${t('row_data')}${i} ${t('invalid')}`);
                                        }, i * 100 + 1000);
                                    }
                                }
                                if (i + 1 === jsonData.length) {
                                    setVisibleExcelProperty(true);
                                }
                            }
                            arrProperties.length > 0
                                ? importExcelProperty([JSON.stringify(arrProperties), +params.idGroup])
                                : toast.error(t('data_file_err'));
                        } else {
                            toast.error(t('data_file_err'));
                        }
                    } else {
                        toast.error(t('file_excel_err'));
                    }
                    // In ra dữ liệu từ file Excel
                };

                reader.readAsArrayBuffer(file);
            } catch (error) {}
            setCheckDataExcelProperty(false);
        } else {
            toast.error(t('file_excel_err'));
        }
        fileInputRefProperty.current.value = '';
    };

    const generateUniqueId = () => {
        const uniqueId = Math.random().toString(36).substr(2, 9);
        return uniqueId;
    };

    // Đưa dữ liệu lên server
    const importExcel = (data) => {
        sendRequest(serviceList.insertExcelDevice, data, importExcelResult, true, timeOutImport, 40000);
    };
    const importExcelResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows;
            const newArr = dataExcel;
            newArr.push(data);
            setDataExcel(JSON.parse(JSON.stringify(newArr)));
            dataLengthRef.current = newArr.length;
            if (dataLengthRef.current === totalDataExcel) {
                setVisibleExcel(true);
            }
        }
    };
    const timeOutImport = (reqInfo) => {};

    const deleteExcelResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        }
    };
    const timeOutDeleteTabbelExcel = (reqInfo) => {};

    // Đưa dữ liệu lên server
    const importExcelProperty = (data) => {
        sendRequest(
            serviceList.uploadExcelGroupsProperty,
            data,
            importExcelResultProperty,
            true,
            timeOutImportProperty,
            40000
        );
    };

    const importExcelResultProperty = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            return;
        } else {
            const data = message.proc_data.rows;
            const newArr = dataExcelProperty;
            newArr.push(data);
            setDataExcelProperty(JSON.parse(JSON.stringify(newArr)));
            dataLengthRefProperty.current = newArr.length;
            if (dataLengthRefProperty.current === totalDataExcelProperty) {
                setVisibleExcelProperty(true);
            }
        }
    };
    const timeOutImportProperty = (reqInfo) => {};

    const deleteTableExcelProperty = () => {
        const InVal = [];
        sendRequest(
            serviceList.delExcelGroupsProperty,
            InVal,
            deleteExcelResultProperty,
            true,
            timeOutDeleteTabbelExcelProperty,
            40000
        );
    };

    const deleteExcelResultProperty = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        }
    };
    const timeOutDeleteTabbelExcelProperty = (reqInfo) => {};

    // get groups
    const getDataGroups = useCallback(() => {
        if (getGroup.current) {
            return;
        }
        getGroup.current = true;
        const InVal = [+params.idGroup];
        sendRequest(serviceList.getIDgroup_devices, InVal, getDataResultGroups, true, timeOutFunctGroups, 40000);
    }, []);

    const getDataResultGroups = (reqInfoMap, message) => {
        getGroup.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // setGroups(message.proc_data.rows[0].o_1);
            setProperty(message.proc_data.rows[0].o_1[0].group_properties);
            setInfoGroup({
                group_cd: message.proc_data.rows[0].o_1[0].group_cd,
                group_nm: message.proc_data.rows[0].o_1[0].group_nm,
            });
        }
    };

    const getDataAllGroup = () => {
        if (getAllGroup.current) {
            return;
        }
        getAllGroup.current = true;
        const InVal = [+params.idPermission, 'all'];
        sendRequest(serviceList.getAllgroup_devicesUser, InVal, getDataAllGroupResult, true, timeOutFunctGroups, 40000);
    };

    const getDataAllGroupResult = (reqInfoMap, message) => {
        getAllGroup.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataAllGroup(
                message.proc_data.rows[0].o_1?.map((ele) => ({ ...ele, checked: ele.id === +params.idGroup }))
            );
        }
    };

    useEffect(() => {
        console.log('dataAllGroup: ', dataAllGroup);
    }, [dataAllGroup]);

    const timeOutFunctGroups = (reqInfo) => {
        getGroup.current = false;
        getAllGroup.current = false;
    };

    return (
        <>
            <Helmet>
                <title> {t('lay_muon_tb')}</title>
            </Helmet>

            <Container>
                <CreatePropertyExcelModal
                    setVisible={setVisibleExcelProperty}
                    visible={visibleExcelProperty}
                    dataExcel={dataExcelProperty}
                    setDataExcel={setDataExcelProperty}
                />
                <Loader loading={getFlags} />
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1} flexWrap={'wrap'}>
                    <Typography variant="h4" gutterBottom>
                        {t('manage_group_device')} :
                        <span style={{ fontWeight: 500, fontSize: 14, marginLeft: 8 }}>
                            {`${infoGroup.group_nm} (${infoGroup.group_cd})`}
                        </span>
                    </Typography>{' '}
                </Stack>
                <CreateDeviceExcelModal
                    visible={visibleExcel}
                    setVisible={setVisibleExcel}
                    setDataExcel={setDataExcel}
                    dataExcel={dataExcel}
                    fuctGet={getData}
                />
                <UpdateDeviceLocationExcelModal
                    visible={visibleDeviceLocationExcel}
                    setVisible={setVisibleDeviceLocationExcel}
                    setDataExcel={setDataExcelDeviceLocation}
                    dataExcel={dataExcelDeviceLocation}
                    fuctGet={getData}
                    property={property}
                />
                <DowloadDeviceLocationExample t={t} tableRef={tableDeviceLocationRef} property={property} />
                {/* {tableData.length > 0 && (
                    <PrintsQRCodeModal
                        visible={visibleDownloadQR}
                        setVisible={setVisibleDownloadQR}
                        data={tableData}
                    />
                )} */}
                <Breadcrumb
                    paths={[
                        {
                            label: t('group_devices'),
                            url: `/home/group-device/${params.idPermission}`,
                            navigate: false,
                        },
                        { label: t('lay_muon_tb'), url: '#', navigate: false },
                    ]}
                />
                <DeviceModal
                    isEdit={isEdit.current}
                    idPermission={params.idPermission}
                    idGroup={params.idGroup}
                    visible={visible}
                    dataUpdate={data}
                    fuctGet={getData}
                    setVisible={setVisible}
                />
                <ConfirmModal
                    loading={deleleFlags}
                    visible={visibleDel}
                    setVisible={setVisibleDel}
                    handleDelete={handleDelete}
                />{' '}
                <Grid container spacing={2}>
                    <FilterDevice
                        getValue={fillterSearcher}
                        setProperties={setProperties}
                        arrProperties={arrProperties}
                        dataAllGroup={dataAllGroup}
                        setDataAllGroup={setDataAllGroup}
                    />
                </Grid>
                <Stack display={'flex'} flexDirection={'row'} flexWrap={'wrap'} gap={2}>
                    <Stack display={'flex'} flexDirection={'row'} flexWrap={'wrap'} gap={2}>
                        <ManyButton
                            nameMain={t('import')}
                            startIcon={<Iconify icon="mingcute:file-import-line" />}
                            listButton={[
                                {
                                    label: t('import') + ' ' + t('properties_group') + ' excel',
                                    // onClick: handleFileUpload,
                                    htmlFor: 'importproperty',
                                },
                                {
                                    label: t('import') + ' excel' + ' ' + t('device'),
                                    // onClick: handleFileUpload,
                                    htmlFor: 'import',
                                },
                                {
                                    label: t('import') + ' excel' + ' ' + t('device_location'),
                                    // onClick: handleFileUpload,
                                    htmlFor: 'import_device_location',
                                },
                            ]}
                        />
                        <ManyButton
                            nameMain={t('download_file')}
                            startIcon={<Iconify icon="mingcute:file-download-line" />}
                            listButton={[
                                {
                                    label: t('download_file') + ' ' + t('properties_group'),
                                    component: RouterLink,
                                    target: '_blank',
                                    download: true,
                                    to: `${glb_sv.urlDownloadFileExcel('ExampleGroupProperties.xlsx')}`,
                                    href: `${glb_sv.urlDownloadFileExcel('ExampleGroupProperties.xlsx')}`,
                                },
                                {
                                    label: t('download_file') + ' ' + t('device'),
                                    onClick: onDownload,
                                },
                                {
                                    label: t('download_file') + ' ' + t('device_location'),
                                    onClick: onDownloadDeviceLocationExmaple,
                                },
                            ]}
                        />
                        <ManyButton
                            nameMain={t('export_list')}
                            startIcon={<Iconify icon="mingcute:file-export-line" />}
                            listButton={[
                                {
                                    label: t('export_list') + ' ' + t('device'),
                                    onClick: onDownloadExportDevices,
                                },
                                {
                                    label: t('export_list') + ' ' + t('property'),
                                    onClick: onDownloadProperty,
                                },
                                {
                                    label: t('export_list') + ' ' + t('device') + ' ' + t('location'),
                                    onClick: () =>
                                        exportToExcel(
                                            tableLocationDeviceRef,
                                            t('export_list') + ' ' + t('device') + ' ' + t('location')
                                        ),
                                },
                            ]}
                        />
                    </Stack>
                    <input
                        accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        type="file"
                        hidden
                        ref={fileInputRefProperty}
                        onChange={handleFileUploadProperty}
                        id="importproperty"
                        name="importproperty"
                    />
                    <input
                        accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        type="file"
                        hidden
                        ref={fileInputRef}
                        onChange={handleFileUpload}
                        id="import"
                        name="import"
                    />
                    <input
                        accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        type="file"
                        hidden
                        ref={fileInputRefDeviceLocation}
                        onChange={handleFileUploadLocationDeviceProperty}
                        id="import_device_location"
                        name="import_device_location"
                    />
                </Stack>
                <Stack direction="row" flexWrap={'wrap'} padding={2} spacing={1}>
                    {arrProperties.length > 0 &&
                        arrProperties.map((item, index) => {
                            return (
                                <div key={index} style={{ gap: 1, margin: 1 }}>
                                    {item?.value?.length > 0 &&
                                        item.value.map((value, idx) => {
                                            if (value.checked) {
                                                return (
                                                    <Chip
                                                        variant="outlined"
                                                        key={idx}
                                                        sx={{ marginLeft: 1 }}
                                                        label={glb_sv.convertMultipleLanguages(value?.label)}
                                                        color="primary"
                                                        // onClick={() => handleClick(item, index)}
                                                        onDelete={() => handleDeletePrototy(item, idx, index)}
                                                    />
                                                );
                                            }
                                        })}
                                </div>
                            );
                        })}
                </Stack>
                <Grid container alignItems="center" mb={1} spacing={2}>
                    <Grid item xs={12} md={10}>
                        <Typography variant="h5" gutterBottom>
                            {t('list_device')} :{' '}
                            <span style={{ fontWeight: 400, fontSize: 15, marginLeft: 8 }}>
                                {dataAllGroup
                                    .filter((ele) => ele.checked)
                                    .map((ele) => ele.group_nm + ` (${ele.group_cd})`)
                                    .join(', ') || ''}
                            </span>
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Box display="flex" justifyContent="flex-end">
                            <ProductFilterSidebarHaveGroup
                                openFilter={openFilter}
                                valueChange={arrProperties}
                                getValue={setProperties}
                                onCloseFilter={() => setOpenFilter(false)}
                                onOpenFilter={() => setOpenFilter(true)}
                                dataAllGroup={dataAllGroup}
                                setDataAllGroup={setDataAllGroup}
                            />
                        </Box>
                    </Grid>
                </Grid>
                {tableData.length > 0 ? (
                    <ProductList
                        products={tableData}
                        setData={setData}
                        functEdit={() => {
                            isEdit.current = true;
                            // setData(item);
                            setVisible(true);
                        }}
                        functDelete={() => setVisibleDel(true)}
                        screenPermissions={screenPermissions}
                    />
                ) : (
                    <EmtyData></EmtyData>
                )}
                {screenPermissions?.insert_permission === '1' && tableData?.length > 0 ? (
                    <AddButton
                        onClick={() => {
                            isEdit.current = false;
                            setVisible(true);
                            setData({});
                        }}
                    />
                ) : (
                    ''
                )}
                {tableData?.length === 0 ? (
                    <AddButton
                        onClick={() => {
                            isEdit.current = false;
                            setVisible(true);
                            setData({});
                        }}
                    />
                ) : (
                    ''
                )}
            </Container>
            <TableContainer sx={{}} style={{ display: 'none' }}>
                <Table ref={tableRef}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="right">{t('code_cabinet')}</TableCell>
                            <TableCell align="right">{'ID' + ' ' + t('drawer')}</TableCell>
                            <TableCell align="right">{t('cell')}</TableCell>
                            <TableCell align="right">{t('Min')}</TableCell>
                            <TableCell align="right">{t('Max')}</TableCell>
                            <TableCell align="right">{t('code_group_devices')}</TableCell>
                            <TableCell align="right">{t('name_device')}</TableCell>
                            <TableCell align="right">{t('code_device')}</TableCell>

                            <TableCell align="right">{t('price')}</TableCell>
                            <TableCell align="right">{t('checking_after')}</TableCell>
                            <TableCell align="right">{t('status_device')}</TableCell>
                            <TableCell align="right">{t('code_department')}</TableCell>
                            <TableCell align="right">{t('code_supplier')}</TableCell>
                            {property?.length > 0 &&
                                property.map((item, index) => (
                                    <TableCell key={index} align="right">
                                        {item?.label}
                                    </TableCell>
                                ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>TuVuong</TableCell>
                            <TableCell>{'1'}</TableCell>
                            <TableCell align="right">{'[2:1]'}</TableCell>
                            <TableCell>{'0'}</TableCell>
                            <TableCell>{'10'}</TableCell>
                            <TableCell>K8436DH</TableCell>
                            <TableCell align="right">Khoan CNC 001</TableCell>
                            <TableCell align="right">MATHIETBI01</TableCell>

                            <TableCell align="right">{199000}</TableCell>
                            <TableCell align="right">{''}</TableCell>
                            <TableCell align="right">{'1'}</TableCell>
                            <TableCell align="right">{'BPD83, MANAGER001, STAFF001, BPC346'}</TableCell>
                            <TableCell align="right">{'NAH7834'}</TableCell>
                            {property?.length > 0 &&
                                property.map((item, index) => (
                                    <TableCell key={index} align="right">
                                        {`TEST00${index}`}
                                    </TableCell>
                                ))}
                        </TableRow>
                        <TableRow>
                            <TableCell>TuTron</TableCell>
                            <TableCell>{'1'}</TableCell>
                            <TableCell align="right">{'5'}</TableCell>
                            <TableCell>{'1'}</TableCell>
                            <TableCell>{'10'}</TableCell>
                            <TableCell>K8436DH</TableCell>
                            <TableCell align="right">Khoan CNC 002</TableCell>
                            <TableCell align="right">MATHIETBI02</TableCell>

                            <TableCell align="right">{199000}</TableCell>
                            <TableCell align="right">{'1'}</TableCell>
                            <TableCell align="right">{'0'}</TableCell>
                            <TableCell align="right">{'BPD83, MANAGER001, STAFF001, BPC346'}</TableCell>
                            <TableCell align="right">{'NAH7834'}</TableCell>
                            {property?.length > 0 &&
                                property.map((item, index) => (
                                    <TableCell key={index} align="right">
                                        {`TEST00${index}`}
                                    </TableCell>
                                ))}
                        </TableRow>
                        <TableRow>
                            <TableCell> </TableCell>
                            <TableCell> </TableCell>
                            <TableCell align="right"> </TableCell>
                            <TableCell> </TableCell>
                            <TableCell> </TableCell>
                            <TableCell>K8436DH</TableCell>
                            <TableCell align="right">Khoan CNC 003</TableCell>
                            <TableCell align="right">MATHIETBI03</TableCell>

                            <TableCell align="right">{199000}</TableCell>
                            <TableCell align="right">{'1'}</TableCell>
                            <TableCell align="right">{'0'}</TableCell>
                            <TableCell align="right">{'BPD83, MANAGER001, STAFF001, RDDEV'}</TableCell>
                            <TableCell align="right">{'NAH7834'}</TableCell>
                            {property?.length > 0 &&
                                property.map((item, index) => (
                                    <TableCell key={index} align="right">
                                        {`TEST00${index}`}
                                    </TableCell>
                                ))}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <TableContainer>
                <Table ref={tableRefExportDevice} sx={{ display: 'none' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="right">{t('stt')}</TableCell>
                            <TableCell align="right">{t('code_group_devices')}</TableCell>
                            <TableCell align="right">{t('name_device')}</TableCell>
                            <TableCell align="right">{t('code_device')}</TableCell>

                            <TableCell align="right">{t('price')}</TableCell>
                            <TableCell align="right">{t('checking_after')}</TableCell>
                            <TableCell align="right">{t('status_device')}</TableCell>
                            <TableCell align="right">{t('code_department')}</TableCell>
                            <TableCell align="right">{t('code_supplier')}</TableCell>
                            {property?.length > 0 &&
                                property.map((item, index) => (
                                    <TableCell key={index} align="right">
                                        {item?.label}
                                    </TableCell>
                                ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData.length > 0 &&
                            tableData.map((item, index) => {
                                return (
                                    <TableRow hover key={index} tabIndex={-1} role="checkbox">
                                        <TableCell component="th" scope="row" padding="none">
                                            {index + 1}
                                        </TableCell>
                                        <TableCell align="left">{item?.group_cd}</TableCell>
                                        <TableCell align="left" sx={{ minWidth: '140px' }} width={200}>
                                            {item?.device_nm}
                                        </TableCell>
                                        <TableCell align="left" width={200}>
                                            {item?.device_cd}
                                        </TableCell>

                                        <TableCell align="left">{item?.price}</TableCell>
                                        <TableCell align="left">{item?.expiry_date}</TableCell>
                                        <TableCell align="left">{item?.status_action}</TableCell>
                                        <TableCell align="left">
                                            {item?.depart_json?.length > 0 &&
                                                item.depart_json.map((depart_cd, idx) => {
                                                    let str = '';
                                                    str += depart_cd.label + ', ';
                                                    return str;
                                                })}
                                        </TableCell>
                                        <TableCell align="left">{item?.supplier_cd}</TableCell>
                                        {property?.map((prop, idx) => {
                                            let matchingArray = item?.properties_device?.find(
                                                (item) => item.label === prop.label
                                            );
                                            if (matchingArray) {
                                                return (
                                                    <TableCell key={idx} align="left">
                                                        {matchingArray.value}
                                                    </TableCell>
                                                );
                                            } else {
                                                return (
                                                    <TableCell key={idx} align="left">
                                                        {''}
                                                    </TableCell>
                                                );
                                            }
                                        })}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TableLocationDevice data={dataLocationDeviceExcel} tableRef={tableLocationDeviceRef} property={property} />
            <TableProperty property={property} tableRef={tablePropertyRef} />
        </>
    );
}
